import { DEFAULT_PAGINATION } from '../../../../../common/query/defaults'
import { SystemSettingsListQuery } from './query.types'

export const DEFAULT_SYSTEM_SETTINGS_QUERY: SystemSettingsListQuery = {
  ...DEFAULT_PAGINATION,
  service: 'core',
}
